import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { PHONE_NUMBER } from "@/lib/api";

const NAV = [
  { label: "Home", href: "/" },
  { label: "Servizi", href: "/#servizi" },
  { label: "Perché Noi", href: "/#perche-noi" },
  { label: "Richiedi Preventivo", href: "/#richiesta" },
  { label: "Contatti", href: "/#contatti" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <img src="/logo.png" alt="Officina Franco" className="h-14 w-auto" />
          <div className="leading-tight hidden sm:block">
            <div className="font-serif-display text-xl text-slate-900 tracking-tight">
              Officina <span className="text-red-600">Franco</span>
            </div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500">
              Riparazioni Meccaniche · Dal 1992
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[12px] tracking-[0.15em] uppercase text-slate-600 hover:text-blue-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`}
            data-testid="header-phone"
            className="hidden md:inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 text-[11px] tracking-[0.2em] uppercase transition-colors"
          >
            <Phone className="w-3.5 h-3.5" /> {PHONE_NUMBER}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 border border-slate-300 flex items-center justify-center text-slate-700"
          >
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-5 flex flex-col gap-3">
            {NAV.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.15em] uppercase text-slate-700 py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`}
              className="bg-red-600 text-white px-5 py-3 text-xs tracking-[0.2em] uppercase mt-2 text-center"
            >
              {PHONE_NUMBER}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
